<script lang="ts" setup>
defineProps<{
  badges: number[]
  size?: 'sm' | 'md' | 'lg' | 'xl'
}>()

const badgeList: Record<number, string> = {
  1: 'D',
  2: 'D+',
  3: 'C',
  4: 'C+',
  5: 'B',
  6: 'B+',
  7: 'A',
  8: 'A+',
  9: 'S',
  10: '未知领域',
  11: '花好月圆',
  12: '虎年大吉',
  13: '纯爱战士',
  14: '爱国者',
  15: 'NTR达人',
  16: 'NTR冠军',
  17: '靓号',
  18: '金皮卡',
  19: '月曼中秋',
  20: '喵爪印记',
  21: '劳动节'
}

const sizeMap: Record<string, number> = {
  sm: 30,
  md: 60,
  lg: 80,
  xl: 120
}
</script>

<template>
  <div class="m-badge" :class="size ?? 'sm'">
    <n-popover
      v-for="badge in badges.slice(0, 5)"
      :key="badge"
      trigger="hover"
      class="m-badge__item"
    >
      <template #trigger>
        <img
          :src="`https://resource.mfuns.net/image/badge/${badge}.png?image_process=resize,w_${
            sizeMap[size || 'md']
          }`"
          :alt="badge.toString()"
        />
      </template>
      <span>{{ badgeList[badge] }}</span>
    </n-popover>
  </div>
</template>

<style lang="scss" scoped>
.m-badge {
  margin: 0 4px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  &__item {
    margin-right: 8px;
  }

  &.sm {
    img {
      width: 20px;
      height: 20px;
    }
  }
  &.md {
    img {
      width: 32px;
      height: 32px;
    }
  }
  &.lg {
    img {
      width: 48px;
      height: 48px;
    }
  }
  &.xl {
    img {
      width: 64px;
      height: 64px;
    }
  }
}
</style>
